import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function AllComicsSection() {
  const allComics = comics.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 12);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">
              全部漫画
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按更新时间排序的韩国漫画作品列表</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {allComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center justify-between text-background-50 text-xs">
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line"></i></span>
                      {(comic.totalViews / 10000).toFixed(0)}万
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-accent-500"></i></span>
                      {comic.rating}
                    </span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">
                {comic.totalChapters}话 · {comic.author}
              </p>
            </Link>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            浏览全部漫画
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}